module.exports = __webpack_public_path__ + "static/media/CryptoDappers.3bf979a9.jpg";